module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-table"
  }, [_c('div', {
    staticClass: "headings"
  }, [(_vm.groupTitle) ? _c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.groupTitle)
    }
  }) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.table.title || "Produktauswahl"))])]), _vm._v(" "), _c('table', {
    staticClass: "table is-striped is-narrow"
  }, [_c('thead', [_c('tr', _vm._l((_vm.table.config), function(column, key) {
    return (!column.disabled) ? _c('th', {
      key: key,
      domProps: {
        "innerHTML": _vm._s(column.label)
      }
    }) : _vm._e()
  }), 0)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.table.data), function(product, productIndex) {
    return _vm._l((_vm._.get(product, _vm.table.multiRowPath, 1)), function(multiRowIndex) {
      return _c('tr', {
        key: productIndex + '-' + multiRowIndex,
        class: multiRowIndex === 1 ? 'parentRow' : 'childRow'
      }, _vm._l((_vm.table.config), function(column, columnIndex) {
        return _c('tablefield', {
          key: productIndex + '-' + multiRowIndex + '-' + columnIndex,
          attrs: {
            "column": column,
            "product": product,
            "secondary-index": multiRowIndex - 1
          }
        })
      }), 1)
    })
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60227859"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/table/TableShortlistProducts.vue
// module id = 691
// module chunks = 0